'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _footer = require('../../footer');

var _footer2 = _interopRequireDefault(_footer);

var _clone = require('../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MPPGivingFundFooter = function (_MPPFooter) {
  _inherits(MPPGivingFundFooter, _MPPFooter);

  function MPPGivingFundFooter() {
    _classCallCheck(this, MPPGivingFundFooter);

    return _possibleConstructorReturn(this, (MPPGivingFundFooter.__proto__ || Object.getPrototypeOf(MPPGivingFundFooter)).apply(this, arguments));
  }

  return MPPGivingFundFooter;
}(_footer2.default);

exports.default = MPPGivingFundFooter;


var secondaryLogo = {
  imageUrl: 'https://www.paypalobjects.com/digitalassets/c/website/logo/full-text/pp_giving_fund.svg'
};
var footNoteLogo = {
  imageUrl: 'https://www.paypalobjects.com/digitalassets/c/website/logo/full-text/au-acnc.png'
};

var newProps = (0, _clone2.default)(_footer2.default.defaultProps);
delete newProps.content.secondaryLinks;
newProps.content.secondaryLogo = secondaryLogo;
newProps.content.footNoteLogo = footNoteLogo;

MPPGivingFundFooter.defaultProps = newProps;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/giving-fund-footer/jsx/MPPGivingFundFooter.js
// module id = 1095
// module chunks = 4